
import { defineComponent } from 'vue'
export default defineComponent({
  data () {
    return {}
  },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    image: {
      type: Object
    }
  }
})
